import { defineStore } from 'pinia'
import { getCustomerPlanService } from '../service/index'

// 定义套餐信息store
export const usePlanStore = defineStore('plan', {
  // 状态
  state: () => ({
    planData: null
  }),
  
  // getters
  getters: {
    // 获取套餐信息
    getPlanData: (state) => state.planData,
    // 判断是否有套餐
    hasPlan: (state) => !!state.planData
  },
  
  // actions
  actions: {
    // 获取套餐信息
    async fetchPlanData() {
      this.loading = true
      this.error = null
      
      try {
        const res = await getCustomerPlanService()
        if (res?.code === 200) {
          this.planData = res.data
        } 
      } catch (error) {
        console.error(error?.message)
       
      } finally {
        
      }
      
      return this.planData
    },
    
    // 设置套餐数据（用于从外部直接设置数据）
    setPlanData(data) {
      this.planData = data
    }
  }
}) 